import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { NODE_HANDLE_IDS } from '@containers/flow/nodes';
import { Body5 } from '@ui';
import styled from 'styled-components';
import { colorPalette } from '@theme';

const SHOW_NAME_HANDLE_STYLE = {
  top: '76px',
  right: '3px',
  zIndex: 1000,
};
const DEFAULT_HANDLE_STYLE = {
  top: '17px',
  right: '4px',
  zIndex: 1000,
};
const NameWrapper = styled.div`
  text-transform: uppercase;
  letter-spacing: -0.3px;
  padding-bottom: 4px;
  pointer-events: auto;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  user-select: none;

  &:hover {
    opacity: 0.8;
  }

  * {
    font-size: 12px !important;
    color: ${colorPalette.secondary.brightGreen};
  }
`;
const PositionName = styled.div`
  position: absolute;
  display: flex;
  flex-direction: row;
  align-items: center;

  padding-left: 8px;

  top: 61px;
  right: 14px;

  height: 34px;
  pointer-events: auto;
`;

const Wrapper = styled.div`
  position: relative;
`;
const Label = styled.div`
  position: absolute;
  top: 8px;
  right: 12px;
  pointer-events: auto;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  user-select: none;

  &:hover {
    opacity: 0.8;
  }
`;

export default React.memo(({ data, showName, isConnectable, nodeId, onRemoveConnectedEdges }) => {
  const id = NODE_HANDLE_IDS.planStep;
  const name = 'Plan Steps';

  const handleDoubleClick = () => {
    if (!isConnectable) return;
    if (onRemoveConnectedEdges) {
      onRemoveConnectedEdges(nodeId, id, 'source');
    }
  };

  return (
    <Wrapper>
      {showName ? (
        <PositionName onDoubleClick={handleDoubleClick}>
          <NameWrapper $disabled={!isConnectable}>
            <Body5 bold>{name}</Body5>
          </NameWrapper>
        </PositionName>
      ) : (
        <Label onDoubleClick={handleDoubleClick} $disabled={!isConnectable}>
          <Body5 bold uppercase>
            Output
          </Body5>
        </Label>
      )}

      <Handle
        type="source"
        id={id}
        position={Position.Right}
        style={{
          background: colorPalette.secondary.brightGreen,
          cursor: isConnectable ? undefined : 'not-allowed',
          ...(showName ? SHOW_NAME_HANDLE_STYLE : DEFAULT_HANDLE_STYLE),
        }}
        onConnect={(params) => console.log('handle onConnect', params)}
        isConnectable={isConnectable}
        isConnectableStart={isConnectable}
      />
    </Wrapper>
  );
});
